var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackSlash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04688 0.859375C9.34766 1.02344 9.45703 1.43359 9.26562 1.76172L1.82812 14.4492C1.66406 14.75 1.25391 14.8594 0.925781 14.668C0.625 14.4766 0.515625 14.0938 0.707031 13.7656L8.14453 1.07812C8.33594 0.777344 8.71875 0.667969 9.04688 0.859375Z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSlash);
export default __webpack_public_path__ + "static/media/back-slash.f8075919b118948285ffba3d777f0b86.svg";
export { ForwardRef as ReactComponent };